import {images} from "../constants";

export const services = [
    {
        id: 1,
        name: "Refonte Instagram",
        description: "Je m'occupe de faire une refonte de ton Instagram, cela comprend : photo de profil, biographie, stories à la une, charte graphique, nouveau feed.",
        img: images.insta,
    },
    {
        id: 2,
        name: "Audit 1h",
        description: "On analyse ensemble tes réseaux (Insta / Tiktok), les points forts et les axes d'améliorations, puis je te donnerai mes conseils pour optimiser tes réseaux.",
        img: images.audit,
    },
    {
        id: 3,
        name: "Identité Visuelle",
        description: "On prévoit un rdv afin de définir ensemble : typographie, palette de couleurs. Puis un second rdv pour finaliser le rendu.",
        img: images.identite,
    },
    {
        id: 4,
        name: "Pack Basique",
        description: "Pendant 1 mois : Création stratégie de contenu, calendrier éditorial, 5 créations visuelles, et 5 créations story.",
        img: images.basic,
    },
    {
        id: 5,
        name: "Pack Confort",
        description: "Pendant 1 mois : Le pack basique, mais avec 1 story tous les 2 jours, et 1 post tous les 3 jours.",
        img: images.confort,
    },
    {
        id: 6,
        name: "Pack Complet",
        description: "Pendant 1 mois : Le Pack Basique + templates Canva, conseils / assistance, 1 post et 1 story par jour. J'offre avec ce pack la refonte Instagram d'une valeur de 180€, et en bonus, création vidéo et retouche photo.",
        img: images.complet,
    },
    {
        id: 7,
        name: "Coaching",
        description: "En visio ou en réel, je te donne des conseils pour améliorer tes réseaux (Tiktok / Instagram), et augmenter ta visibilité",
        img: images.coaching,
    },
    {
        id: 8,
        name: "Support de Com",
        description: "Je créé tes supports de communication (cartes de visites, flyers, affiches, brochures).",
        img: images.com,
    }
]